import type { PatientGroup } from "@care-by-ella/contracts";

// The patient's journey, at a glance. A "receptövertag" is the case that
// changes what the doctor does — she is already on treatment and must not be
// sent to a consultation — so it carries the same warning styling as the Test
// badge rather than sitting quietly next to "Ny behandling".
const GROUP_STYLE: Record<PatientGroup, { label: string; className: string }> =
  {
    NEW_TREATMENT: {
      label: "Ny behandling",
      className:
        "bg-surfaceMuted/40 text-textSecondary border border-surfaceMuted",
    },
    PRESCRIPTION_TRANSFER: {
      label: "Receptövertag",
      className: "bg-warning/15 text-warning border border-warning/60",
    },
  };

export function PatientGroupBadge({ group }: { group: PatientGroup }) {
  const { label, className } = GROUP_STYLE[group];
  return (
    <span
      className={`align-middle text-xs font-sans font-medium uppercase tracking-wide rounded px-xs py-[2px] ${className}`}
    >
      {label}
    </span>
  );
}
